import React, { useState, useEffect } from 'react'
import Box from '@mui/material/Box'
import SwipeableDrawer from '@mui/material/SwipeableDrawer'
import PropTypes from 'prop-types'
import * as OnboardEntity from '../../Entities/OnBoardingContainerTypes'
import { useRiskStore } from './Store/RiskStore'
import { IconButton, Tooltip } from '@mui/material'
import { IoIosCloseCircleOutline } from 'react-icons/io'

const ViewComments = ({ setIsViewComments, isViewComments }) => {
    const [ windowWidth, setWindowWidth ] = useState(window.innerWidth)
    const RiskDetailsById = useRiskStore((state) => state.RiskDetailsById)
    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth)
        }

        window.addEventListener('resize', handleResize)
        return () => {
            window.removeEventListener('resize', handleResize)
        }
    }, [])

    const toggleDrawer = (anchor, open) => (event) => {
        if (
            event &&
            event.type === OnboardEntity.KEYDOWN &&
            (event.key === OnboardEntity.TAB || event.key === OnboardEntity.SHIFT)
        ) {
            return
        }

        setIsViewComments({ ...isViewComments, [anchor]: open })
    }

    const list = (anchor) => (
        <Box className="h-[100%]">
            <Box className="p-6 flex justify-between items-center">
                <h2 className="text-xl font-semibold text-primary">{'Comments'}</h2>
                <Tooltip title="Close" placement="left" arrow componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                    <IconButton onClick={() => setIsViewComments({ ...isViewComments, right: false })} aria-label="close">
                        <IoIosCloseCircleOutline className='text-[hsl(var(--primary))]' />
                    </IconButton>
                </Tooltip>
            </Box>
            <Box className="border-b-[1.5px]"></Box>
            <Box className="p-6 pt-8">
                <div className='flex flex-col h-[90%]'>
                    {RiskDetailsById?.riskInformation?.raisedName && <div className='flex flex-col'>
                        <p className='font-bold pb-2'>
                            <span className='text-xl font-medium text-primary'>Raised Department Manager - </span>
                            <span className='text-xl font-medium text-muted'>{RiskDetailsById?.riskInformation?.raisedName}</span>
                        </p>
                        <p className='font-bold p-4 border-[1.5px] border-primary rounded-lg bg-[#007a7810]'>
                            <span className={`text-md font-medium text-muted ${RiskDetailsById?.riskInformation?.raisedRemarks?.length === 0 ? 'italic opacity-40' : ''}`}>
                                {RiskDetailsById?.riskInformation?.raisedRemarks || 'No Comments'}
                            </span>
                        </p>
                    </div>}
                    {RiskDetailsById?.riskInformation?.ownerName && <div className='flex flex-col mt-6'>
                        <p className='font-bold pb-2'>
                            <span className='text-xl font-medium text-primary'>Owned Department Manager - </span>
                            <span className='text-xl font-medium text-muted'>{RiskDetailsById?.riskInformation?.ownerName}</span>
                        </p>
                        <p className='font-bold p-4 border-[1.5px] border-primary rounded-lg bg-[#007a7810]'>
                            <span className={`text-md font-medium text-muted ${RiskDetailsById?.riskInformation?.raisedRemarks?.length === 0 ? 'italic opacity-40' : ''}`}>
                                {RiskDetailsById?.riskInformation?.ownerRemarks || 'No Comments'}
                            </span>
                        </p>
                    </div>}
                </div>
            </Box>
        </Box>
    )

    return (
        <div>
            <SwipeableDrawer
                PaperProps={{ sx: { width: windowWidth / 3, overflowX: 'hidden', zIndex: 0 } }}
                className='m-2 z-auto'
                anchor={'right'}
                open={isViewComments.right}
                onClose={toggleDrawer('right', false)}
                onOpen={toggleDrawer('right', true)}
            >
                {list('right')}
            </SwipeableDrawer>
        </div>
    )
}

ViewComments.propTypes = {
    setnewNode: PropTypes.func,
    setIsViewComments: PropTypes.func,
    isViewComments: PropTypes.func
}

export default ViewComments
